var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      title: _vm.$gettext("Bearbeitungszeit verlängern"),
      confirmText: _vm.$gettext("Verlängern"),
      confirmClass: "accept",
      closeText: _vm.$gettext("Abbrechen"),
      closeClass: "cancel",
    },
    on: {
      close: _vm.onClose,
      confirm: _vm.onConfirm,
    },
    scopedSlots: _vm._u([
      {
        key: "dialogContent",
        fn: function fn() {
          return [
            _c(
              "form",
              {
                staticClass: "default",
              },
              [
                _c(
                  "p",
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$gettext("Aktuelle Bearbeitungszeit:")) +
                        " "
                    ),
                    _c("StudipDate", {
                      attrs: {
                        date: _vm.startDate,
                      },
                    }),
                    _vm._v(" - "),
                    _c("StudipDate", {
                      attrs: {
                        date: _vm.endDate,
                      },
                    }),
                    _vm._v(
                      "\n                (" +
                        _vm._s(
                          _vm.$gettextInterpolate(
                            _vm.$gettext("%{ count } Tage"),
                            {
                              count: _vm.oldDuration,
                            }
                          )
                        ) +
                        ")\n            "
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "formpart",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "studiprequired",
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "textlabel",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$gettext(
                                  "Bearbeitungszeit verlängern bis zum"
                                )
                              )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "asterisk",
                            attrs: {
                              title: _vm.$gettext("Dies ist ein Pflichtfeld"),
                              "aria-hidden": "true",
                            },
                          },
                          [_vm._v("*")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.localEndDate,
                              expression: "localEndDate",
                            },
                          ],
                          staticClass: "size-l",
                          attrs: {
                            id: "task-groups-".concat(_vm.uid),
                            name: "end-date",
                            type: "date",
                            min: _vm.endDateString,
                            required: "",
                          },
                          domProps: {
                            value: _vm.localEndDate,
                          },
                          on: {
                            input: function input($event) {
                              if ($event.target.composing) return
                              _vm.localEndDate = $event.target.value
                            },
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$gettext("Verlängerte Bearbeitungszeit:")) +
                        " "
                    ),
                    _c("StudipDate", {
                      attrs: {
                        date: _vm.startDate,
                      },
                    }),
                    _vm._v(" - "),
                    _c("StudipDate", {
                      attrs: {
                        date: _vm.newEndDate,
                      },
                    }),
                    _vm._v(
                      "\n                (" +
                        _vm._s(
                          _vm.$gettextInterpolate(
                            _vm.$gettext("%{ count } Tage"),
                            {
                              count: _vm.newDuration,
                            }
                          )
                        ) +
                        ")\n            "
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }